<template>
  <div style="display: table;width: 100%;overflow: hidden;background: #efeff4;">
    <div style="height: calc(100% - 4rem);overflow: scroll;">
      <ph-empty
        v-if="!cardList.length"
        :content="`您还未添加任何${ftype === '1' ? '就诊卡' : '住院号'}`"
        :fullscreen="false"
      />
      <div v-for="item in getCardList" :key="item.cardId" class="card-item">
        <div v-if="item.isDefault" class="header-view">龙岩人民医院</div>
        <div class="content-view">
          <img
            :src="require('@assets/ic_card_list_user-portrait.png')"
            alt=""
          />
          <div>
            <div>{{ item.cardNo }}</div>
            <div style="font-weight: 500;font-size: .94rem">
              {{ item.name }}
            </div>
          </div>
          <div style="margin-right: 0;margin-left: auto;">
            <div v-if="item.isDefault === '1'">
              <div class="card-selected">
                使用中
              </div>
              <div
                v-show="cardList.length === 1"
                @click="deleteCard(item)"
                style="display: flex;align-items: center;margin-top: .5rem"
              >
                <img
                  :src="require('@assets/ic_delete.png')"
                  alt=""
                  style="width: 1.5rem;height: 1rem;margin-right: .2rem;background: none;"
                />删除
              </div>
            </div>
            <div v-else class="ctl-view">
              <div @click="setDefault(item)" style="display: flex;">
                <img
                  :src="require('@assets/ic_selected.png')"
                  style="margin-right: .2rem;"
                  alt=""
                />使用
              </div>
              <div
                @click="deleteCard(item)"
                style="display: flex;align-items: center;margin-top: .5rem"
              >
                <img
                  :src="require('@assets/ic_delete.png')"
                  alt=""
                  style="width: 1.5rem;height: 1rem;margin-right: .2rem;"
                />删除
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-view">
      <ph-button @click="bindCard" type="primary">
        <van-icon name="plus" />
        关联{{ ftype === "1" ? "卡片" : "住院号" }}
      </ph-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [],
      ftype: "1"
    };
  },
  computed: {
    getCardList() {
      var list = [];
      var tmpList = [];
      for (var item of this.cardList) {
        if (item.isDefault) {
          list.push(item);
        } else {
          tmpList.push(item);
        }
      }
      return list.concat(tmpList);
    }
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$api.USER_CARD_LIST, {
          functionType: this.ftype
        })
        .then(res => {
          this.cardList = res;
        });
    },
    bindCard() {
      this.$router.push({
        name: "relative-card",
        query: {
          ftype: this.ftype
        }
      });
    },
    setDefault(item) {
      this.$http
        .post(this.$api.USER_SET_DEFAULT_CARD, {
          functionType: "1",
          cardNo: item.cardNo,
          cardType: item.cardType
        })
        .then(() => {
          this.loadData();
        });
    },
    deleteCard(item) {
      this.$dialog
        .confirm({
          title: "删除卡片",
          message: "是否确认删除卡片"
        })
        .then(() => {
          this.$http
            .post(this.$api.USER_DELETE_CARD, {
              functionType: "1",
              cardId: item.cardId,
              cardType: item.cardType
            })
            .then(() => {
              this.$toast("删除成功");
              this.loadData();
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.card-item {
  margin: 1rem 1rem 0 1rem;
  background: white;
  border-radius: 0.5rem;
}
.header-view {
  padding: 0.8rem 0.5rem;
  color: white;
  background: #108eee;
  border-radius: 0.5rem 0.5rem 0 0;
}

.content-view {
  display: flex;
  align-items: center;
  padding: 0.8rem;
  font-size: 0.88rem;
  border-radius: 0 0 0.5rem 0.5rem;

  img {
    flex-shrink: 0;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 1rem;
    border-radius: 50%;
  }

  .card-selected {
    padding: 0 0.4rem;
    color: white;
    line-height: 2rem;
    background: #108eee;
  }
}

.btn-view {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2.8rem;
  padding: 0.5rem 0;
  background: white;
  .van-button {
    width: calc(100% - 2rem);
    font-size: 1rem;
    background-color: #108eee;
    border: none;
    border-radius: 0.2rem;
  }

  i {
    padding: 0.1rem;
    border: 1px solid white;
    border-radius: 50%;
  }
}
.ctl-view {
  font-size: 0.85rem;
  img {
    width: 1.5rem;
    height: 1.5rem;
    background: none;
  }
}
</style>
